import i18n from "./i18n";

const fieldError = (code, values = []) => {
  return i18n.t(`errors.fieldErrors.${code}`, values);
};

export default fieldError;
